import { createContext } from 'react';

type CoreContextType = {
  fastMode?: boolean;
};

export const CoreContext = createContext<CoreContextType | null>(null);
